import { createSlice as e } from "@reduxjs/toolkit";
const i = { data: {} }, d = e({
  name: "dataSharing",
  initialState: i,
  reducers: {
    saveData: (a, t) => {
      a.data = { ...a.data, [t.payload.key]: t.payload.value };
    }
  }
}), { saveData: r } = d.actions;
export {
  d,
  r as s
};
